module.exports = __webpack_public_path__ + "media/components/brandings/svgs/downloadLanding/branding-download-logo-ad55c29bbc6872f44cd1e715fc825f0e.svg";